var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('van-overlay',{staticClass:"overlay",attrs:{"show":_vm.show},on:{"click":function($event){_vm.show = false}}},[_c('img',{attrs:{"show-menu-by-longpress":true,"src":_vm.url}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }